import { Text } from '@chakra-ui/react';
import React from 'react';

import { useMeshRunRecord } from '../../hooks/instanceGraphContext';
import { getRelativeTime } from 'packages/dataPipeline/ui/utils/getTimeElapsed';

export const GraphFooter = () => {
  const { updatedAt, startedAt } = useMeshRunRecord();

  const startedAtStr = new Date(startedAt).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZoneName: 'short',
  });

  const lastUpdatedStr = getRelativeTime(updatedAt);
  const footerText = `Started ${startedAtStr}, Last Updated ${lastUpdatedStr}`;

  return (
    <Text mt="10px" fontSize={14} fontWeight={500} color="gray" size="14px">
      {footerText}
    </Text>
  );
};
